// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pizC34fCewNRtajf6j_b{padding-bottom:21px}`, "",{"version":3,"sources":["webpack://./src/App/components/FormError/FormError.module.scss"],"names":[],"mappings":"AAAA,sBAAW,mBAAmB","sourcesContent":[".formError{padding-bottom:21px}:export{red:var(--color-red)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"red": `var(--color-red)`,
	"formError": `pizC34fCewNRtajf6j_b`
};
export default ___CSS_LOADER_EXPORT___;
